import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureCosmosDbIcon = props => (
  <Icon viewBox="0 0 721 720" w="full" h="full" color="inherit" {...props}>
    <defs>
      <clipPath id="clip0">
        <path
          d="M875.263 302.247C906.688 433.782 825.531 565.886 693.998 597.312 562.463 628.733 430.359 547.58 398.935 416.047 367.51 284.51 448.667 152.406 580.2 120.982 711.733 89.559 843.837 170.714 875.26 302.247Z"
          fillRule="nonzero"
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <g transform="translate(-277 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M395.864 211.914C392.008 211.936 388.864 208.827 388.842 204.971 388.842 204.944 388.842 204.917 388.842 204.89L388.842 204.89C388.776 160.648 352.927 124.798 308.683 124.733 304.82 124.733 301.683 121.612 301.661 117.749 301.661 113.872 304.806 110.727 308.683 110.727 352.941 110.66 388.799 74.7864 388.842 30.528 388.821 26.6724 391.929 23.5278 395.785 23.5062 395.812 23.5062 395.837 23.5062 395.864 23.5062 399.721 23.4828 402.864 26.5914 402.888 30.4488 402.888 30.474 402.888 30.501 402.888 30.528 402.952 74.772 438.803 110.621 483.045 110.687 486.903 110.666 490.047 113.773 490.069 117.63 490.069 117.655 490.069 117.682 490.069 117.709 490.09 121.567 486.982 124.709 483.126 124.733 483.099 124.733 483.072 124.733 483.045 124.733 438.794 124.776 402.931 160.639 402.888 204.89 402.864 208.76 399.734 211.891 395.864 211.914Z"
                stroke="currentColor"
                strokeWidth="39.9001"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M900.879 698.294C897.771 698.294 895.252 695.777 895.252 692.669L895.252 692.669C895.209 657.274 866.53 628.592 831.135 628.549 828.042 628.549 825.528 626.056 825.508 622.964 825.508 619.855 828.026 617.337 831.135 617.337 866.537 617.314 895.229 588.622 895.252 553.217 895.252 550.111 897.771 547.592 900.879 547.592 903.988 547.592 906.504 550.111 906.504 553.217 906.529 588.622 935.221 617.314 970.624 617.337 973.732 617.337 976.251 619.855 976.251 622.964 976.251 626.071 973.732 628.589 970.624 628.589 935.229 628.634 906.549 657.313 906.504 692.708 906.481 695.801 903.972 698.294 900.879 698.294Z"
                stroke="currentColor"
                strokeWidth="39.9001"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M875.263 302.247C906.688 433.782 825.531 565.886 693.998 597.312 562.463 628.733 430.359 547.58 398.935 416.047 367.51 284.51 448.667 152.406 580.2 120.982 711.733 89.559 843.837 170.714 875.26 302.247Z"
                stroke="currentColor"
                strokeWidth="39.9001"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <g clipPath="url(#clip0)">
                <path
                  d="M505.788 525.089C541.871 526.034 571.89 497.549 572.835 461.468 573.78 425.383 545.295 395.366 509.212 394.421 508.137 394.393 507.063 394.391 505.988 394.416 506.182 392.56 506.274 390.695 506.267 388.831 505.939 352.526 476.299 323.332 439.995 323.554L390.997 323.554C381.293 396.844 404.603 470.66 454.638 525.089Z"
                  stroke="currentColor"
                  strokeWidth="39.9001"
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit="4"
                  strokeOpacity="1"
                  fill="none"
                  fillRule="nonzero"
                  fillOpacity="1"
                />
                <path
                  d="M878.295 313.618C878.295 313.02 878.295 312.422 878.016 311.863 870.124 269.167 850.729 229.435 821.917 196.951 818.178 195.437 814.324 194.236 810.386 193.36 772.118 182.441 732.241 204.613 721.32 242.883 719.756 248.368 718.847 254.016 718.615 259.713 715.967 259.407 713.301 259.234 710.635 259.195 672.358 259.191 641.326 290.219 641.325 328.496 641.321 357.84 659.8 384.005 687.453 393.817 694.329 396.511 701.653 397.867 709.039 397.807L790.037 397.807C822.559 373.189 852.169 344.943 878.295 313.618Z"
                  stroke="currentColor"
                  strokeWidth="39.9001"
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit="4"
                  strokeOpacity="1"
                  fill="none"
                  fillRule="nonzero"
                  fillOpacity="1"
                />
              </g>
              <path
                d="M963.921 154.697C938.823 112.921 880.131 96.642 798.137 108.851 770.043 112.833 742.281 118.861 715.065 126.886 736.654 134.339 757.155 144.63 776.031 157.489 785.647 155.376 795.304 152.861 804.561 151.465 819.123 149.198 833.831 148.01 848.569 147.913 877.841 143.694 907.264 154.582 926.734 176.841L926.734 176.841C942.016 202.298 929.128 245.828 891.382 296.541 838.927 361.834 774.643 416.668 701.898 458.176 630.78 502.562 551.953 533.18 469.52 548.429 407.116 557.766 362.508 548.429 347.226 523.053 331.944 497.677 344.832 454.027 382.578 403.553 387.246 397.289 388.403 394.216 393.709 387.913 391.216 366.28 391.564 344.416 394.748 322.875 377.785 339.88 362.175 358.182 348.065 377.618 298.628 443.732 285.222 503.183 310.279 544.959 337.216 580.997 381.295 599.981 425.989 594.794 442.704 594.706 459.388 593.374 475.905 590.803 563.894 574.744 648.075 542.257 724.042 495.043 801.627 450.643 870.135 392.002 925.977 322.196 975.572 255.924 988.978 196.511 963.921 154.697Z"
                stroke="currentColor"
                strokeWidth="39.9001"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
